<template>
  <div class="bgc score">
    <Loading v-if="loading" />
    <div class="title">
      <div class="sort_son_title">
        {{ itemTitle }}
      </div>
      <div class="right_div">
        <span class="mr-12 ft-14"> {{ $t('exam.stunameLabel') }}:</span>
        <a-input-search
          v-model="studentName"
          style="width: 200px"
          :placeholder="$t('exam.stunameplac')"
          @search="getCompetencylevel()"
        />
        <a-button
          v-if="tableData && tableData.length"
          class="btn"
          type="primary"
          ghost
          @click="importTo"
        >
          {{ $t('exam.downbtn') + itemTitle }}
        </a-button>
      </div>
    </div>
    <div class="table_div">
      <Table :columns="columns" :data="tableData" :pagination="false" />
      <div v-if="withoutPage.total > withoutPage.pageSize" class="page-box">
        <a-pagination
          v-model="withoutPage.pageIndex"
          show-quick-jumper
          show-size-changer
          :hide-on-single-page="true"
          :default-page-size="withoutPage.pageSize"
          :total="withoutPage.total"
          @change="onChange"
          @showSizeChange="showSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import axios, { getCookie } from '@utils'
  import ApiXy from '@lib/api.js'
  import Table from '@comp/tables/sortTable.vue'
  import Loading from '@comp/loading'
  export default {
    components: {
      Table,
      Loading
    },
    props: {
      id: {
        type: String,
        default: ''
      },
      itemTitle: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        loading: false,
        studentName: '',
        // title: '学生层次错题表',
        columns: [
          // {
          //   title: '姓名',
          //   dataIndex: 'studentName',
          //   width: 150
          // },
          // {
          //   title: '学科',
          //   dataIndex: 'courseName',
          //   width: 150,
          //   customRender: (value, row) => {
          //     const obj = {
          //       children: value,
          //       attrs: {}
          //     }
          //     obj.attrs.rowSpan = !row.courFirst ? 2 : 0
          //     return obj
          //   }
          // }
        ],
        tableData: [],
        query: {},
        subjectList: 0,
        pagination: {
          pageSize: 10,
          total: 0,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '100', '200', '500']
        },
        withoutPage: {
          pageIndex: 1,
          pageSize: 10,
          total: 0,
          showQuickJumper: true,
          showSizeChanger: true
        },
        pageStart: 0
      }
    },
    watch: {
      $route() {
        this.getCompetencylevel()
      }
    },
    created() {
      this.query = this.$route.query
    },
    mounted() {
      this.getCompetencylevel()
    },
    methods: {
      // 按学生姓名搜索
      onChange(pageIndex) {
        this.getCompetencylevel(pageIndex)
      },
      showSizeChange(current, size) {
        this.withoutPage.pageSize = size
        this.getCompetencylevel()
      },
      getCompetencylevel(pageIndex = 1) {
        this.withoutPage.pageIndex = pageIndex //更新分页
        this.loading = true
        let { meId, classId, GradeId, campusId } = this.$route.query
        let params = {
          meId,
          classId: classId,
          gradeId: GradeId,
          pageSize: this.withoutPage.pageSize,
          pageIndex,
          searchText: this.studentName,
          campusId
        }
        axios({
          url: 'getstudenttopicwrongdetail',
          params,
          loading: false
        })
          .then(res => {
            this.loading = false
            let tableData = []
            let maxNum = 0
            this.withoutPage.total = res.data.total
            res.data &&
              res.data.items.forEach(itemc => {
                maxNum < itemc.MaxTopicCount && (maxNum = itemc.MaxTopicCount)
                let iItemc = JSON.parse(JSON.stringify(itemc))
                delete iItemc.courseTopicList
                itemc.courseTopicList.forEach(itemd => {
                  let iItemd = JSON.parse(JSON.stringify(itemd))
                  //delete iItemd.topicHQuestionList
                  // itemd.topicHQuestionList.forEach(iteme => {

                  // })
                  tableData.push({
                    ...iItemc,
                    ...iItemd
                  })
                })
              })

            let tableDataA = tableData.map(item => {
              item.topicHQuestionList.forEach((itemc, indexc) => {
                item['topicHName' + indexc] = itemc.topicHName
                item['questionNumber' + indexc] = itemc.questionNumber
                  ? itemc.questionNumber.join(',')
                  : ''
              })
              return item
            })

            let tableDataB = []
            let studentId = -1
            tableDataA.forEach(item => {
              item.colFirst = studentId !== item.studentId
              let obja = {
                courFirst: true,
                studentName: this.$t('exam.xiaoyang'),
                courseName: this.$t('exam.xiaoyang'),
                courseId: item.courseId,
                studentId: item.studentId
              }
              for (let m = 0; m < maxNum; m++) {
                obja['topicHName' + m] = item['questionNumber' + m]
              }
              tableDataB.push(item)
              tableDataB.push(obja)
              studentId = item.studentId
            })

            tableData = tableDataB
            let columns = [
              {
                title: this.$t('exam.stuErrorColum[0]'),
                dataIndex: 'studentName',
                width: 150
              },
              {
                title: this.$t('exam.stuErrorColum[1]'),
                dataIndex: 'courseName',
                width: 150,
                customRender: (value, row) => {
                  const obj = {
                    children: value,
                    attrs: {}
                  }
                  obj.attrs.rowSpan = !row.courFirst ? 2 : 0
                  return obj
                }
              }
            ]
            let columnsb = []
            for (let m = 0; m < maxNum; m++) {
              let colData = {
                title: this.$t('exam.stuErrorColum[2]'),
                dataIndex: 'topicHName' + m,
                colSpan: !m ? maxNum : 0
              }
              columnsb.push(colData)
            }
            this.columns = columns.concat(columnsb)
            //表头合并
            this.columns[0].customRender = (value, row) => {
              const obj = {
                children: value,
                attrs: {}
              }

              let len = 0
              res.data.items.forEach(item => {
                row.studentId === item.studentId &&
                  (len = item.courseTopicList.length)
              })
              let slLen = len * 2
              obj.attrs.rowSpan = row.colFirst ? slLen : 0
              return obj
            }

            this.pagination.total = tableData.length
            this.pagination.pageSize = tableData.length
            this.tableData = tableData
          })
          .catch(() => {
            setTimeout(() => {
              this.loading = false
            }, 200)
          })
      },
      //数字检测
      checkNumber(val) {
        let reg = /^\d+(.\d+)?$/
        return reg.test(val)
      },
      importTo() {
        let url =
          `${ApiXy.defaulteApi.host}` +
          `${ApiXy.defaulteApi.path.exportstudenttopicwrongdetail}` +
          '?campusId=' +
          this.$route.query.campusId +
          '&meId=' +
          this.$route.query.meId +
          '&classId=' +
          this.$route.query.classId +
          '&gradeId=' +
          this.$route.query.GradeId +
          '&X-ZYLX-TOKEN=' +
          getCookie('X-ZYLX-TOKEN')
        window.open(url, '_blank', '')
      }
    }
  }
</script>

<style lang="less" scoped>
  .score {
    height: 100%;
    background: #fff;
    .left {
      float: left;
    }
    .right {
      float: right;
    }
    .title {
      // height: 58px;
      // line-height: 58px;
      // font-size: 16px;
      // color: rgba(0, 0, 0, 0.85);
      // margin-top: -50px;
      .left_div {
        margin-left: 24px;
      }
      .right_div {
        margin-right: 24px;
        .btn {
          margin-left: 12px;
        }
      }
    }
    .table_div {
      height: calc(100% - 58px);
      padding: 0 20px;
      .echartName {
        padding: 0 10%;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
      }
      /deep/ .ant-table-body {
        border-top: 1px solid #e8e8e8;
        border-bottom: 1px solid #e8e8e8;
        max-width: 100%;
        overflow-x: auto;
        table {
          border-top: 0;
          tr td {
            // width: 120px;
            &:first-child {
              width: auto;
            }
            &:nth-child(2) {
              width: auto;
            }
          }
        }
      }
      .echarts {
        margin-top: 82px;
        .echarts_list {
          width: 100%;
          height: 400px;
          margin-bottom: 32px;
        }
      }
    }
  }

  .chartText {
    display: inline-block;
    opacity: 0;
  }
  .page-box {
    padding: 30px 10px 10px;
    text-align: center;
  }
</style>
